import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppLayout from "@/components/layout/AppLayout";
import { apiPrivate } from "@/lib/api";
import { Users, FileText, ShieldCheck, ArrowUpRight } from "lucide-react";

export default function AdminOverview() {
    const [stats, setStats] = useState(null);

    useEffect(() => {
        apiPrivate.get("/admin/soci/stats").then(r => setStats(r.data)).catch(() => {});
    }, []);

    return (
        <AppLayout admin>
            <div className="max-w-[1400px] mx-auto" data-testid="admin-overview">
                <span className="label-tag text-magenta">Admin Console</span>
                <h1 className="font-display text-5xl lg:text-7xl mt-3 tracking-tighter">Panoramica.</h1>
                <p className="text-zinc-400 mt-4 max-w-xl">Tutto quello che succede sulla piattaforma in un colpo d'occhio.</p>

                <div className="grid grid-cols-12 gap-4 mt-12" data-testid="admin-stats">
                    <Stat big icon={Users} label="Soci totali" value={stats?.total_soci ?? "—"} color="acid" testid="stat-total" />
                    <Stat icon={Users} label="Soci attivi" value={stats?.active_soci ?? "—"} testid="stat-active" />
                    <Stat icon={ShieldCheck} label="Richieste pending" value={stats?.pending_requests ?? "—"} color="magenta" testid="stat-pending" />
                    <Stat icon={FileText} label="Documenti" value={stats?.total_documents ?? "—"} testid="stat-docs" />
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-10">
                    <div className="bento p-10" data-testid="quota-distribution">
                        <span className="label-tag">— Distribuzione per categoria quota</span>
                        <div className="grid grid-cols-4 gap-3 mt-6">
                            {["A", "B", "C", "D"].map(q => (
                                <div key={q} className="border border-zinc-800 p-4 text-center" data-testid={`quota-${q}-count`}>
                                    <div className="font-display text-5xl text-acid">{stats?.by_quota?.[q] ?? 0}</div>
                                    <div className="text-xs uppercase tracking-widest font-grotesk text-zinc-500 mt-2">Quota {q}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="bento p-10" data-testid="quick-actions">
                        <span className="label-tag">— Azioni rapide</span>
                        <div className="space-y-2 mt-6">
                            <Link to="/admin/soci" className="flex items-center justify-between bento p-4 hover:border-acid transition" data-testid="qa-manage-soci">
                                <span className="font-grotesk">Gestione soci</span>
                                <ArrowUpRight className="h-4 w-4 text-acid" />
                            </Link>
                            <Link to="/admin/documenti" className="flex items-center justify-between bento p-4 hover:border-acid transition" data-testid="qa-publish-doc">
                                <span className="font-grotesk">Pubblica nuovo documento</span>
                                <ArrowUpRight className="h-4 w-4 text-acid" />
                            </Link>
                            <Link to="/admin/faq" className="flex items-center justify-between bento p-4 hover:border-acid transition" data-testid="qa-manage-faq">
                                <span className="font-grotesk">Aggiorna FAQ</span>
                                <ArrowUpRight className="h-4 w-4 text-acid" />
                            </Link>
                            <Link to="/admin/richieste" className="flex items-center justify-between bento p-4 hover:border-acid transition" data-testid="qa-requests">
                                <span className="font-grotesk">Verifica richieste accesso</span>
                                <ArrowUpRight className="h-4 w-4 text-acid" />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    );
}

function Stat({ big, icon: Icon, label, value, color = "acid", testid }) {
    return (
        <div className={`bento p-8 ${big ? "col-span-12 md:col-span-6" : "col-span-6 md:col-span-2"}`} data-testid={testid}>
            <Icon className={`h-6 w-6 ${color === "magenta" ? "text-magenta" : "text-acid"} mb-6`} />
            <div className={`font-display ${big ? "text-7xl lg:text-8xl" : "text-5xl"} tracking-tighter`}>{value}</div>
            <div className="text-zinc-500 text-xs uppercase tracking-widest font-grotesk mt-3">{label}</div>
        </div>
    );
}
